import script from "./HospitalProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./HospitalProducts.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__